import type { ReactNode } from "react";

import { type ImageSizer, ImageSizerContext } from "./imageContext.js";

/**
 * Sizes every image below it that says how wide it is drawn (ItemArt's `width`), through the app's
 * sizer, so a row of small cards never downloads full-size photos. Mount once near the root:
 *
 *   <ImageProvider size={sizeItemImage}>…</ImageProvider>
 *
 * Without a provider, images load at their original size.
 */
export function ImageProvider({ size, children }: { size: ImageSizer; children: ReactNode }) {
  return <ImageSizerContext.Provider value={size}>{children}</ImageSizerContext.Provider>;
}
